<template>
  <div>
    <b-navbar class="nav-top" type="dark">
      <b-navbar-brand tag="h1" class="mb-0">
        <b style="font-size: 20px">KMP-Procurement</b>
      </b-navbar-brand>
    </b-navbar>
    <b-navbar toggleable="lg" class="nav-bottom">
      <b-navbar-toggle target="navbar" v-if="navbottomStatus"></b-navbar-toggle>
      <b-collapse id="navbar" is-nav v-if="navbottomStatus">
        <b-navbar-nav v-if="!customer">
          <b-nav-item-dropdown text="ข้อมูล Ebidding" left>
            <b-dropdown-item router-link to="/Overview"
              >ประกาศผู้ชนะการเสนอราคา</b-dropdown-item
            >
            <b-dropdown-item router-link to="/Company"
              >ข้อมูลบริษัท</b-dropdown-item
            >
          </b-nav-item-dropdown>
          <b-nav-item router-link to="/User" v-if="admin">
            <b>บัญชีผู้ใช้</b>
          </b-nav-item>
          <b-nav-item router-link to="/Requests">
            <b>เเจ้งข้อมูลผิด</b>
          </b-nav-item>
          <b-nav-item router-link to="/CRM">
            <b>การบริหารสัมพันธ์ลูกค้า: CRM</b>
          </b-nav-item>
          <b-nav-item router-link to="/UploadAds" v-if="false">
            <b>อัพโหลดไฟล์โฆษณา</b>
          </b-nav-item>
        </b-navbar-nav>
        <b-navbar-nav class="ml-auto">
          <b-nav-item-dropdown right>
            <template v-slot:button-content>
              <em>
                <font-awesome-icon icon="user-alt" />
                &nbsp;&nbsp;{{ username }}
              </em>
            </template>
            <b-dropdown-item @click="logout" href="#"
              >ออกจากระบบ</b-dropdown-item
            >
          </b-nav-item-dropdown>
        </b-navbar-nav>
      </b-collapse>
    </b-navbar>
  </div>
</template>

<script>
import axios from "axios";
export default {
  data() {
    return {
      username: null,
      navbottomStatus: false,
      customer: true,
      adsManage: true,
      admin: false,
    };
  },
  mounted() {
    if (window.location.pathname !== "/ebidding/View") {
      if (
        window.location.hash !== "#/" &&
        this.$session.get("fullname") === undefined
      ) {
        this.$router.push("/");
      } else if (window.location.hash === "#/") {
        this.navbottomStatus = false;
      } else {
        this.navbottomStatus = true;
        this.username = this.$session.get("fullname");
      }
      if (
        this.$session.get("role") === "Customer" ||
        this.$session.get("role") === "Engineer"
      ) {
        this.customer = true;
      } else {
        this.customer = false;
      }
      axios.get("https://api.ipify.org?format=json").then((res) => {
        this.$session.set("ipaddress", res.data.ip);
      });
      if (this.$session.get("username") === "wannisa") {
        this.adsManage = true;
      }
      if (this.$session.get("role") === "Admin") {
        this.admin = true;
      } else {
        this.admin = false;
      }
    }
  },
  methods: {
    logout: function () {
      this.$session.destroy();
      this.$router.push("/");
    },
  },
};
</script>

<style>
.nav-link {
  color: white !important;
}
.nav-top {
  background-color: rgb(27, 27, 27);
  font-family: "Taviraj" !important;
}
.nav-bottom {
  font-family: "Taviraj" !important;
  background-color: #005a7c;
  font-size: 12px;
}

.nav-item a.nav-link:hover {
  background-color: rgb(27, 27, 27);
  border-radius: 20px;
  color: white !important;
}
.dropdown a {
  font-weight: bold !important;
}
.navbar-toggler {
  border-color: white !important;
  border: 1px solid #fff !important;
}
.navbar-toggler-icon {
  background-image: url("data:image/svg+xml;charset=utf8,%3Csvg viewBox='0 0 32 32' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath stroke='white' stroke-width='2' stroke-linecap='round' stroke-miterlimit='10' d='M4 8h24M4 16h24M4 24h24'/%3E%3C/svg%3E");
}

.dropdown-menu {
  background-color: rgba(27, 27, 27, 0.924) !important;
  font-size: 12px !important;
}

.dropdown-menu a {
  color: white !important;
}

.dropdown-menu a:hover {
  background-color: #005a7c !important;
  color: white !important;
}
</style>
